import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FeatureFlagService } from '@core/services/feature-flag.service';
import { WorkspaceService } from '@core/services/workspace.service';
import { map } from 'rxjs';

/**
 * Prevents a bookmarked billing URL from loading provider-backed UI while the
 * Payment public API is disabled by deployment configuration.
 */
export const paymentFeatureGuard: CanActivateFn = () => {
  const features = inject(FeatureFlagService);
  const workspace = inject(WorkspaceService);
  const router = inject(Router);

  return features
    .whenKnown('payment')
    .pipe(map((enabled) => enabled || router.createUrlTree([workspace.homeRoute()])));
};
